import ReactMarkdown from 'react-markdown'

import { clsx } from 'clsx'
import remarkGfm from 'remark-gfm'

import { isJerseyProduct } from '@dfds-pax/utils'

import NoIcon from '@/ui-cvi/components/dxp-icons/system/NoIcon'
import StatusSuccessIcon from '@/ui-cvi/components/dxp-icons/system/StatusSuccessIcon'

import { useTranslation } from '@/hooks/useDebugTranslations'

interface Props {
  productCode: string
  soldOut: boolean
}

const TicketInfo: React.FC<Props> = ({ productCode, soldOut }) => {
  const { t } = useTranslation()

  const isJerseyVariant = isJerseyProduct(productCode)

  return (
    <ReactMarkdown
      className={clsx(
        'gap-primitive-16 p-semantic-global-md md:p-semantic-global-lg typography-body-md-regular flex w-full flex-col',
        isJerseyVariant && 'lg:p-0'
      )}
      remarkPlugins={[remarkGfm]}
      components={{
        input({ checked, type, ...props }) {
          if (type === 'checkbox') {
            return checked ? (
              <StatusSuccessIcon className="text-semantic-global-success-default shrink-0" size="lg" />
            ) : (
              <NoIcon className="shrink-0" size="lg" />
            )
          }
          return <input type={type} {...props} />
        },
        li({ children }) {
          if (soldOut) return null
          return <li className="mb-primitive-8 gap-semantic-global-md flex flex-row items-start last:mb-0">{children}</li>
        },
        p({ children }) {
          return (
            <div
              className={clsx(
                isJerseyVariant
                  ? 'typography-heading-sm text-semantic-global-text-default'
                  : soldOut
                    ? 'text-semantic-global-disabled-default'
                    : 'text-component-icon-row-text'
              )}
            >
              {children}
            </div>
          )
        },
        ul({ children }) {
          if (soldOut) return null
          return <ul className="text-component-icon-row-text ml-0">{children}</ul>
        },
      }}
    >
      {t(`${productCode?.toUpperCase()}-TICKET-INFO`)}
    </ReactMarkdown>
  )
}

export default TicketInfo
